module.exports = __webpack_public_path__ + "static/media/feature_flag_main_visual_en.9320ce3d.png";